import { Navigate, Route, Routes } from "react-router-dom";

import ForgotPassword from "./pages/auth/ForgotPassword";
import FundSubmissions from "./pages/FundSubmissions";
import Funds from "./pages/Funds";
import Login from "./pages/auth/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import ResetPassword from "./pages/auth/ResetPassword";
import Submission from "./pages/Submission";
// import logo from "./assets/ncf-stroke-logo.svg";

// this is the main 'body' section of the page between the header and footer
export function Main() {

  return (
    <>
      <div className="bg-gradient-to-br from-slate-700 to-slate-900">
        <div
          className="z-0 bg-cover bg-fixed bg-right bg-repeat"
        // style={{ backgroundImage: `url(${logo})` }}
        >
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/funds"
              element={
                <ProtectedRoute>
                  <Funds />
                </ProtectedRoute>
              }
            />
            <Route
              path="/funds/:fundId"
              element={
                <ProtectedRoute>
                  <FundSubmissions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/funds/:fundId/:submissionId"
              element={
                <ProtectedRoute>
                  <Submission />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate replace to="/funds" />} />
          </Routes>
        </div>
      </div>
    </>
  );
}
